const doc = [({"en":({"js":({"admin":({"sheet_layouts":({"create_card":({"create_sheet_layout":"Create sheet layout"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;